module.exports = __webpack_public_path__ + "img/arrow.843c9aea.svg";